import React, { type SVGProps } from "react";
import { iconSizes, type IconProps } from "./utils/shared";
const FlashlightFill = (props: SVGProps<SVGSVGElement> & IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width={props.size ? iconSizes[props.size] : iconSizes["s"]}
    height={props.size ? iconSizes[props.size] : iconSizes["s"]}
    title="FlashlightFill"
    {...props}
  >
    <path d="M13 10H20L11 23V14H4L13 1V10Z" />
  </svg>
);
export default React.memo(FlashlightFill);
